import {calculatePagesAmount} from '#utils/common.ts';
import {formatDateToDayMonthYearFormat} from '#utils/date.ts';

export const getNotificationsResponseTransformer = ({data, pagination}) => ({
  notifications: data.map(notification => ({
    id: notification.id,
    isRead: notification.is_read,
    title: notification.title,
    text: notification.text,
    date: formatDateToDayMonthYearFormat(notification.created_at),
    type: notification.type
  })),
  pagination: {
    totalItemsAmount: pagination.total,
    totalPagesAmount: calculatePagesAmount({
      totalItems: pagination.total,
      itemsPerPage: pagination.limit
    }),
    currentPage: pagination.current_page,
    limit: pagination.limit,
    hasMore: pagination.has_more
  }
});

const getOrganisationIdFromNotificationEventData = (notification: {
  type: string;
  event_data: {id: number};
}) => {
  const isRequestFromOrganisation =
    notification.type === 'org_to_merchant' || notification.type === 'invite';
  if (isRequestFromOrganisation) {
    return notification.event_data.id;
  }
  return null;
};

export const getNotificationByIdResponseTransformer = ({
  data: notification
}) => ({
  notification: {
    id: notification.id,
    title: notification.title,
    text: notification.text,
    date: formatDateToDayMonthYearFormat(notification.created_at),
    type: notification.type,
    imageUrl: notification.image_url,
    invitationStatus: notification.event_data?.request_status,
    adminMessage: notification.admin_message,
    eventId: notification.event_id,
    eventData: notification.event_data
      ? {
          id: notification.event_data.id,
          name: notification.event_data.name,
          imageUrl: notification.event_data.logo,
          organisationId:
            getOrganisationIdFromNotificationEventData(notification)
        }
      : null
  }
});
